import './Footer.css';
import { footerData } from '../../Config';
import { getVisitorCount, trackVisitor } from '../../../services/CommonService';
import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const Footer = () => {
  // const { correspondenceAddress, registeredAddress, informationLinks, copyrightText, socialLinks } = footerData;
  const [count, setCount] = useState({})
  const getVisitor = async () => {
    try {
      const response = await getVisitorCount();
      setCount(response?.data)
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || error?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const setVisitor = async () => {
    try {
      const response = await trackVisitor();
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || error?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    setVisitor();
    getVisitor();
  }, []);

  return (
    <footer className="main-footer">
      {/* <div className="main-footer__top">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-4 col-xl-2 wow fadeInUp" data-wow-delay="00ms">
              <a href="/" className="footer-widget__logo">
                <img src='/logo.png' alt="ACWADAM Logo" />
              </a>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp add-pad-rt" data-wow-delay="300ms">
              <div className="footer-widget footer-widget--contact">
                <h2 className="footer-widget__title">Correspondence Address:</h2>
                <ul className="list-unstyled footer-widget__contact">
                  {correspondenceAddress && correspondenceAddress.map((item, index) => (
                    <li className="footer-widget__contact__item" key={`correspondence-${index}`}>
                      <div className="footer-widget__contact__icon">
                        <i className={item.icon}></i>
                      </div>
                      <div className="footer-widget__contact__inner">
                        {item.link ? (
                          <a href={item.link} className="footer-widget__contact__text">{item.text}</a>
                        ) : (
                          <p className="footer-widget__contact__text">{item.text}</p>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="500ms">
              <div className="footer-widget footer-widget--contact">
                <h2 className="footer-widget__title">Registered Address:</h2>
                <ul className="list-unstyled footer-widget__contact">
                  {registeredAddress && registeredAddress.map((item, index) => (
                    <li className="footer-widget__contact__item" key={`registered-${index}`}>
                      <div className="footer-widget__contact__icon">
                        <i className={item.icon}></i>
                      </div>
                      <div className="footer-widget__contact__inner">
                        <p className="footer-widget__contact__text">{item.text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-lg-2 col-xl-3 wow fadeInUp link-pad-lt" data-wow-delay="700ms">
              <div className="footer-widget footer-widget--links ">
                <h2 className="footer-widget__title">Information</h2>
                <ul className="list-unstyled footer-widget__links">
                  {informationLinks && informationLinks.map((link, index) => (
                    <li key={`info-link-${index}`}><a href={link.href}>{link.text}</a></li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className='p-1 ms-2 mb-2 bg-dark text-light text-center align-middle count'>
        <h5>{count?.total_visits}</h5>
      </div>
      <div className="main-footer__bottom">
        <div className="container">
          <div className="main-footer__bottom__inner">
            <p className="main-footer__copyright">
              <b>Disclaimer: </b>The content on this website is published and managed by the ACWADAM organization. © All rights reserved by ACWADAM.
            </p>
            {/* <div className="main-footer__social">
              {socialLinks && socialLinks.map((social, index) => (
                <a key={`social-${index}`} href={social.href}><i className={social.icon} aria-hidden="true"></i></a>
              ))}
            </div> */}
          </div>
        </div>
      </div>
      <div className="main-footer__element">
        {/* <img src={footerHand} alt="" /> */}
      </div>
    </footer>
  );
};

export default Footer;